import { Deserializable } from '../../protocols/deserializable';
import { SubmissionStatusIdEnum } from '../../enum/shared/submission-status-id.enum';
import { MemberSubmissionStatus } from '../member-submission-status';
import { SubmissionComment } from '../submission-comment';
import { PortalTypeIdEnum } from '../../enum/shared/portal-type-id.enum';
import { EmployerSubmissionAttachment } from './employer-submission-attachment';
import { SubmissionStatusPill } from '../../shared/submission-status-pill';
import * as moment from 'moment/moment';
import { EmployerSubmissionTypeEnum } from '../../enum/shared/employer-submission-type.enum';
import { UpdateEmployerContactsSubmission } from './submission-bodies/update-contacts/update-employer-contacts-submission';
import { UpdateEmployerAddressSubmission } from './submission-bodies/update-address/update-employer-address-submission';
import { UpdateEmploymentStatusSubmission } from './submission-bodies/update-employment-status/update-employment-status-submission';

export class EpEmployerSubmission implements Deserializable {
  public id!: number;
  public employerId!: number;
  public employerName!: string;
  public submissionTypeId!: EmployerSubmissionTypeEnum;
  public submissionTypeName!: string;
  public statusId!: SubmissionStatusIdEnum;
  public status!: MemberSubmissionStatus;
  public comments!: SubmissionComment[];
  public idPrefix!: string;
  public idSuffix!: string;
  public submittedDate!: string;
  public expirationDate!: string;
  public lastStatusUpdateDate!: string;
  public createdInPortalTypeId!: PortalTypeIdEnum;
  public completedDate!: string;
  public createdDate!: string;
  public attachments!: EmployerSubmissionAttachment[];
  public createdByEmployerUserName!: string | null;
  public updateAddressSubmissionId!: string;
  public updateAddressSubmission!: UpdateEmployerAddressSubmission;
  public updateContactsSubmissionId!: string;
  public updateContactsSubmission!: UpdateEmployerContactsSubmission;
  public updateEmploymentStatusSubmissionId!: string | null;
  public updateEmploymentStatusSubmission!: UpdateEmploymentStatusSubmission | null;

  // Not From API
  public submissionId!: string;
  public formattedExpirationDate!: string;
  public expiringSoon!: boolean;
  public statusPill!: SubmissionStatusPill;
  public completedDateString!: string;
  public createdDateString!: string;

  // We do not display substatus information on EP, so user does not need to know if a submission is approved. Just Completed, Canceled etc
  public isApproved(): boolean {
    return false;
  }

  public onDeserialize() {
    const Deserialize = window?.injector?.Deserialize;
    this.submissionId = this.buildSubmissionId();

    if (!!this.comments) {
      this.comments = Deserialize?.arrayOf(SubmissionComment, this.comments);
    }
    if (!!this.status) {
      this.status = Deserialize?.instanceOf(MemberSubmissionStatus, this.status);
      this.statusPill = new SubmissionStatusPill(this.id, this.status.name, this.statusId, this.status.name);
    }
    if (!!this.attachments) {
      this.attachments = Deserialize?.arrayOf(EmployerSubmissionAttachment, this.attachments);
    }

    if (!!this.expirationDate) {
      this.formattedExpirationDate = moment(this.expirationDate).format('MMMM D, YYYY');
      // if the submission is expiring within the next 10 days, set expiringSoon to true
      this.expiringSoon = moment(this.expirationDate).diff(moment(), 'days') <= 10;
    }

    if (!!this.completedDate) {
      this.completedDateString = this.completedDate;
    }

    if (!!this.createdDate) {
      this.createdDateString = this.createdDate;
    }

    if (!!this.updateAddressSubmission) {
      this.updateAddressSubmission = Deserialize?.instanceOf(
        UpdateEmployerAddressSubmission,
        this.updateAddressSubmission
      );
    }

    if (this.updateEmploymentStatusSubmission) {
      this.updateEmploymentStatusSubmission = Deserialize?.instanceOf(
        UpdateEmploymentStatusSubmission,
        this.updateEmploymentStatusSubmission
      );
    }
  }

  private buildSubmissionId(): string {
    // Submission IDs should be 8 characters long, padded with leading zeros
    const paddedId = this.id.toString().padStart(8, '0');
    return `${this.idPrefix}-${paddedId}-${this.idSuffix}`;
  }
}
